export default {
  setCompanyName: 'setCompanyName',
};
